import { render, staticRenderFns } from "./AddCareerStudentForm.vue?vue&type=template&id=0512d454&scoped=true&"
import script from "./AddCareerStudentForm.vue?vue&type=script&lang=js&"
export * from "./AddCareerStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./AddCareerStudentForm.vue?vue&type=style&index=0&id=0512d454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512d454",
  null
  
)

export default component.exports